import globalContent from 'content/global';
import content from 'content/home';
import Header from 'components/Header';
import HomeHero from 'components/HomeHero';
import Marquee from 'components/Marquee';
// import HomeGallery from 'components/HomeGallery';
import HomeClients from 'components/HomeClients';
import HomeContact from 'components/HomeContact';
import SocialsFooter from 'components/SocialsFooter';

const Home = () => {
  return (
    <div>
      <Header revealOnScroll="true" />
      <HomeHero
        headline={content.hero}
        socials={globalContent.footer.socials}
      />
      <div id="intro" aria-hidden="true"></div>
      {/* <HomeGallery content={content.gallery} id="intro" /> */}
      <HomeClients content={content.clients} />
      <Marquee marqueeItems={content.marquee} />
      <HomeContact faqTabs={content.faq} id="contact" />
      <SocialsFooter content={globalContent.footer} />
    </div>
  );
};

export default Home;
